import PrizesBannerWoResults from 'assets/images/school-league/prizes_every_monday_wo_results.svg';

import LeagueIcon from 'pages/challenge/icons/SpringLeagueIcon';
import BannerBg from 'assets/images/school-league/spring_banner_bg.svg';
import Bg from 'assets/images/school-league/spring_bg.svg';
const color = '#DCF8C2';

const challengeCardBackgroundColor = color;
const ChallengeNavigationIcon = LeagueIcon;
const schoolLeagueBackground = BannerBg;
const schoolLeaguePageBackground = Bg;
const prizesBanner = PrizesBannerWoResults;

export {
  challengeCardBackgroundColor,
  ChallengeNavigationIcon,
  schoolLeagueBackground,
  schoolLeaguePageBackground,
  prizesBanner
};
